import { RetailShopFormData, RetailShopRes } from "../types/retailShop";
import { get, post } from "./fetch.core";

export function getRetailShopId() {
  if (typeof window === "undefined") return null;

  return localStorage.getItem("retailShopId");
}

async function add(data: RetailShopFormData) {
  const rst = await post("/pos/retailShop/create", data);

  return rst.data;
}

async function single(id: string) {
  const res = await get<RetailShopRes>(`/pos/retailShop/single?id=${id}`);
  return res.data;
}

async function deleteRecord(id: string) {
  const res = await post("/pos/retailShop/delete", { id });

  return res.data;
}

async function list() {
  const res = await get<RetailShopRes[]>("/admin/retailShop/list");
  return res.data;
}

async function update(id: string, data: RetailShopFormData) {
  const res = await post("/pos/retailShop/update", {
    id,
    ...data,
  });

  return res.data;
}

const obj = {
  add,
  single,
  deleteRecord,
  update,
  list,
};

export default obj;
